import { QueryFactory } from "../../../../Common";
import { CasinoPlayerActivityAPIQuery_Types } from "../../../../Contracts";
export const QGetLastBetAge = QueryFactory(CasinoPlayerActivityAPIQuery_Types.GetLastBetAge);
//# sourceMappingURL=QGetLastBetAge.js.map